module.exports = __webpack_public_path__ + "fonts/fa-regular-400.9c6f2a1b2322ef037d3d44b2b1a201b4.ttf";